export function toArrayBuffer(buffer) {
  return buffer;
}
export function toBuffer(binaryData) {
  throw new Error('Buffer not supported in browser');
}
//# sourceMappingURL=buffer.browser.js.map